import React from 'react';
import { Link } from 'react-router';

const Attribute = ({ to, text = 'by' }) => {
  const profileURL = `/users/${to}`;

  return (
    <div className="attribution">
      {text} <Link to={profileURL}>{to}</Link>
    </div>
  );
};

export default Attribute;
